module.exports = __webpack_public_path__ + "img/audio.07ca5d77.png";